function isMobileDevice() {
	return /Mobi/.test(navigator.userAgent);
}

export default isMobileDevice;
